<template>
    <div>
        <!-- <div style="display: flex;  align-items: center; gap: 10px;">
        <div>
          <input
            class="form-control ShifokrSverka"
            type="date"
            v-model="datas.datetime1"
          />
        </div>
        <div>
          <input
            class="form-control ShifokrSverka"
            type="date"
            v-model="datas.datetime2"
          />
        </div>
        <b-button class="qoshishBtn" variant="primary" @click="data">
          <span>
            <b-icon icon="arrow-counterclockwise" color="#fff"></b-icon>
            Янгилаш.
          </span>
        </b-button>
      </div> -->
        <div class="palata-category" v-for="(itemCat, indCat) in itemsPalata" :key="indCat">
            <div class="palata-name">
                {{ itemCat.name }}
            </div>
            <div style="display: flex; flex-wrap: wrap;">
                <div class="palata-xona" v-for="(itemXona, indXona) in itemCat.xona" :key="indXona">
                    <div class="p-x-name">
                        <div>{{ itemXona.name }}</div>
                    </div>
                    <div v-for="(itemPal, indPal) in itemXona.palata" class="palata-palata"
                        :class="{ palataStatus: itemPal.status }" :key="indPal">
                        <div style="width: 100%;">
                            <div style="width: 100%;">
                                <div
                                    style="font-size: 16px; font-weight: 600; display: flex; justify-content: space-between;">
                                    <div style="font-size: 16px; font-weight: 600; display: flex;">
                                        <div>{{ itemPal.name }}</div>
                                    </div>
                                    <div style="margin-right: 5px; font-size: 14px;">{{ itemPal.price | numFormat }}
                                    </div>
                                    <!-- <b-button
                      v-if="!itemPal.status"
                      @click="
                          RowClickedPalata(
                          itemPal,
                          itemCat.id,
                          itemXona.id,
                          itemXona.name
                          )
                      "
                      class="navbarBtn navbarBtn-palata"
                      variant="primary"
                      >
                      +
                      </b-button> -->
                                </div>
                                <div style="width: 100%;">
                                    <b-input
                                        style="width: 100%; height: 30px; border: 1px solid #ccc; border-radius: 5px; margin-bottom: 5px;"
                                        disabled type="text" v-model="itemPal.comment">
                                    </b-input>
                                    <!-- <v-select
                      class="palata-select"
                      :disabled="itemPal.status"
                      label="name"
                      :options="User"
                      :reduce="option => option.id"
                      v-model="itemPal.user_id"
                      /> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
    props: ["registration_palata", "hospital_summa", "backlog", "modalId", "modalIdCom"],
    components: {
    },
    data() {
        return {
            lang: {
                formatLocale: {
                    firstDayOfWeek: 1
                },
                monthBeforeYear: false
            },
            localUser: JSON.parse(localStorage.getItem("user")),
            price: 0,
            comment: "",
            User: [],
            vaqt: 0,
            palata: {
                date_to: moment(new Date()).format("X"),
                date_do: moment(new Date()).format("X")
            },
            datas: {
                date_to: new Date().toISOString().slice(0, 10),
                date_do: new Date().toISOString().slice(0, 10)
            },
            itemsPalata: []
        };
    },
    methods: {
        // getPalata() {
        //   let self = this;
        //   console.log(self.palata);
        //   axios({
        //     method: "post",
        //     url: "/registration/palata",
        //     data: self.palata
        //   }).then(res => {
        //     if (res) {
        //       self.itemsPalata = res.data;
        //     }
        //   });
        // },
        data() {
            let self = this;
            let datas = {
                date_to: parseInt(
                    new Date(self.datas.date_to)
                        .valueOf()
                        .toString()
                        .slice(0, 10)
                ),
                date_do:
                    parseInt(
                        new Date(self.datas.date_do)
                            .valueOf()
                            .toString()
                            .slice(0, 10)
                    ) + 86399,
            };
            axios({
                method: "post",
                url: "/registration/palata-bandligi",
                data: datas
            }).then(res => {
                if (res) {
                    self.itemsPalata = res.data;
                }
            });
        }
    },
    mounted() {
        this.data();
    }
}
</script>

<style>
.palata-summ {
    height: 35px;
    width: 100%;
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    border-radius: 5px;
    justify-content: center;
}

/* .custom-modal .modal-dialog .modal-content {
    width: 900px !important; 
  } */
.navbarBtn-palata {
    padding: 0px 7px !important;
}

.palata-select .vs__selected-options span:first-child {
    width: 80% !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
}

.palata-select .vs__selected-options {
    width: 80%;
}

.palata-select {
    height: 30px;
}

.palata-select .vs__dropdown-toggle {
    height: 30px;
}

.palata-category {
    border: 1px solid rgb(46, 165, 255);

    background: #f0f0f03d;
    box-shadow: 5px 8px 10px rgba(25, 95, 176, 0.3);
    border-radius: 10px;
    padding: 10px 5px;
    margin: 10px 5px;
}

.palata-xona {
    border: 1px solid #0b0bdd;
    background: #fff;
    width: 245px;
    margin: 10px 5px;
    border-radius: 7px;
    padding: 7px 7px;
}

.palata-palata {
    display: flex;
    border: 1px solid rgb(46, 165, 255);
    border-radius: 7px;
    background: #f0f0f03d;
    margin: 5px;
    padding: 5px 7px;
}

.palata-name {
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    color: #3f51b5;
}

.p-x-name {
    font-size: 17px;
    font-weight: 600;
    display: flex;
    /* border: 1px solid red; */
    /* margin: 5px 5px; */
    margin-top: 5px;
    justify-content: center;
    padding: 3px 5px;
}

.palataStatus {
    background: #ff00004a !important;
}

.numberic-style {
    height: 35px;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.modalQidiruvp {
    width: 50%;
    float: right;
    /* position: relative; */
    /* left: 50%; */
}

.navbarBtn {
    color: #fff;
    border: 1px solid #fff;
    font-size: 18px;
    font-weight: 600;
    padding: 5px 10px;
    box-shadow: 5px 8px 10px rgba(25, 95, 176, 0.3);
    background: #00009d;
    border-radius: 8px;
}
</style>